import React, { useState } from "react";
import { FormElement, FormLabel, FormInput } from "../StyledElements";
import { Dialog } from "../Dialog";
import { startChatSession } from "../../services/agents";

export const StartAgentChatDialog = ({ agent, title, show, onClose = () => { }, onChatStarted = () => { } }) => {
  const [context, setContext] = useState("");
  const [startChatText, setStartChatText] = useState("Start Chat");


  const startAgentChatDialog = async () => {
    console.log("!!! STARTING AGENT CHAT DIALOG: ", agent);
    setStartChatText("Starting...");
    const chatSession = await startChatSession(agent.public_id, null, context);
    onChatStarted(chatSession);
    setStartChatText("Start Chat");
  }


  return (
    <Dialog
      subtitle={title}
      show={show}
      onClose={onClose}
      onOK={startAgentChatDialog}
      okText={startChatText}
      closeText="Close"
      style={{ width: "600px" }}
    >
      <FormElement style={{ marginBottom: "10px" }}>
        <FormLabel label="Context" />
        <FormInput
          as="textarea"
          placeholder="Enter context for the workflow here (JSON format)"
          onChange={(e) => {
            setContext(e.target.value);
          }}
          style={{ height: "100px", resize: "vertical" }}
        />
      </FormElement>
    </Dialog>
  );
};

export default StartAgentChatDialog;
